import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/button';

// On the shared Hub address (e.g. hub.flair.hr) there is no company to sign in
// to — a customer's Hub lives on their own subdomain (acme.hub.flair.hr). Rather
// than authenticating here (which can't tell tenants apart), ask for the company
// slug and send the browser to `<slug>.<current host>`.
const sanitizeSlug = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .replace(/^https?:\/\//, '')
    .replace(/\..*$/, '') // drop anything the user pasted after the first dot
    .replace(/[^a-z0-9-]/g, '');

const CompanyPicker: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const [slug, setSlug] = useState('');

  const baseHost = window.location.host;
  const suffix = `.${baseHost}`;
  const cleanSlug = sanitizeSlug(slug);

  const goToCompanyHub = (event: React.FormEvent) => {
    event.preventDefault();
    if (!cleanSlug) {
      return;
    }
    window.location.href = `${window.location.protocol}//${cleanSlug}${suffix}`;
  };

  return (
    <form onSubmit={goToCompanyHub}>
      <h1 className="display-4 text-center mb-2">
        {t('signIn.companyPicker.title')}
      </h1>
      <p className="text-muted text-center mb-4">
        {t('signIn.companyPicker.subTitle')}
      </p>

      <div className="input-group input-group-lg mb-4 shadow-sm rounded">
        <input
          type="text"
          className="form-control border-primary"
          placeholder={t('signIn.companyPicker.placeholder')}
          aria-label={t('signIn.companyPicker.placeholder')}
          value={slug}
          onChange={(event) => setSlug(event.target.value)}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
        />
        <span className="input-group-text bg-primary text-white fw-semibold border-primary">
          {suffix}
        </span>
      </div>

      <Button
        type="submit"
        variant="primary"
        className="w-100"
        label={t('signIn.companyPicker.submit')}
        disabled={!cleanSlug}
      />
    </form>
  );
};

export default CompanyPicker;
